import { defineTransitionModifiers } from '../../../../subject/testRunner/graph-state/transition-modifiers';

export const AMPModifiers = defineTransitionModifiers([]);
